<div>
    <div class="modal-header">{{'dso-selector.'+ action + '.' + objectType.toString().toLowerCase() + '.head' | translate}}
        <button type="button" class="close" (click)="close()" aria-label="Close">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
      <div data-test="admin-div" *ngIf="(isAdmin$ | async)">
        <button class="btn btn-outline-primary btn-lg btn-block" (click)="selectObject(undefined)">{{'dso-selector.create.community.top-level' | translate}}</button>
        <div class="h3 position-relative py-1 my-3 font-weight-normal">
            <hr>
            <div id="create-community-or-separator" class="text-center position-absolute w-100">
                <span class="px-4 bg-white">{{'dso-selector.create.community.or-divider' | translate}}</span>
            </div>
        </div>
      </div>
        <span class="h5 px-2">{{'dso-selector.create.community.sub-level' | translate}}</span>
        <ds-authorized-community-selector [currentDSOId]="dsoRD?.payload.uuid"
          [types]="selectorTypes"
          (onSelect)="selectObject($event)"></ds-authorized-community-selector>
    </div>
</div>
